import { FC } from 'react';
import { IconT } from 'shared/assets/icons';
import styles from './styles.module.scss';

interface LogoProps {
    className?: string;
}

export const Logo: FC<LogoProps> = ({ className }) => {
    return (
        <div className={`${styles.logo} ${className || ''}`}>
            <IconT />
        </div>
    );
}; 